module.exports = __webpack_public_path__ + "static/media/Major Project ETRX 2020-21.35eaeb6a.pdf";